// ============================================================
//  src/context/NavigationContext.js
//  Provides a navigate function to non-React code (e.g. axios interceptor)
//  without forcing a full page reload via window.location.href
//
//  How it works:
//    1. NavigationProvider stores a ref to React Router's navigate function
//    2. setNavigate() is called once inside the BrowserRouter tree (in App.js)
//    3. api/client.js calls navigateTo('/login') instead of window.location.href
// ============================================================

let _navigate = null;

/** Called by the RouterSetter component inside <BrowserRouter> */
export function setNavigate(fn) {
  _navigate = fn;
}

/** Called by axios interceptor — safe to use outside React */
export function navigateTo(path) {
  if (_navigate) {
    _navigate(path, { replace: true });
  } else {
    // Fallback if router not mounted yet (edge case)
    window.location.href = path;
  }
}
